import styled from 'styled-components';
import Icon from 'components/commons/Icon';

import {
  colorWhite,
  mediaQueryMobileMin,
  mediaQueryMobileLargeMin,
  fontFamilyPrimary,
  colorBlack900,
  colorPrimaryDarken10,
  colorPrimaryLighten95,
  colorPrimary,
  colorPrimary200,
} from 'styles';

export const Wrapper = styled.div`
  overflow: hidden;
  position: relative;

  &:after {
    content: '';
    position: absolute;
    top: 0;
    right: 0;
    width: 32px;
    height: 40px;
    background: linear-gradient(
      270deg,
      #ffffff 0%,
      rgba(255, 255, 255, 0) 100%
    );
  }

  @media all and ${mediaQueryMobileMin} {
    width: auto;

    &:after {
      display: none;
    }
  }
`;

export const Button = styled.button`
  align-items: center;
  font-family: ${fontFamilyPrimary};
  line-height: 31px;
  height: 32px;
  font-size: 14px;
  color: ${colorBlack900};
  background: ${colorWhite};
  border: 1px solid #cacccb;
  border-radius: 4px;
  padding: 0 8px;
  margin-right: 8px;
  white-space: nowrap;

  &:last-child {
    overflow: hidden;
    text-overflow: ellipsis;
  }

  ${props => {
    if (props['data-checked']) {
      return `
      background: ${colorPrimaryLighten95};
      border-color: ${colorPrimary200};
      color: ${colorPrimary}!important;
      `;
    }
    return '';
  }}

  &:hover {
    color: ${colorPrimaryDarken10};
    background: ${colorPrimaryLighten95};
  }
`;

export const Group = styled.div`
  display: flex;

  @media all and ${mediaQueryMobileLargeMin} {
    max-width: 100%;
  }
`;

export const StyledIcon = styled(Icon)`
  margin-right: 5px;
`;
